export const ProgressColorUtil = (value: number) => {
  const newVal = 85 - (value - 1) * 0.46;

  return `hsl(245,100%,${newVal}%)`;
};
